// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"499":"6e70a3a4","781":"0505e4ef"}[chunkId] + ".css";
};